import React, { useState } from "react";
import { connect } from "react-redux";
import { useTranslation } from "core/hooks/useTranslation";

import { Form, Col, Row, Checkbox } from "antd";

import Modal from "components/common/modal";
import Input from "components/common/input";

import { addDomain } from "store/actions/portal/projects/domains.action";

import { POPUP_SIZE } from "constants/common.constants";
import { DOMAIN_REGEX } from "constants/regex.constants";

const AddDomainComponent = ({
    addDomain,
    isSaving,
    type,
    onClose,
}) => {
    const { t } = useTranslation();
    const [formInstance] = Form.useForm();
    const { validateFields } = formInstance;

    const [value, setValue] = useState("")

    const handleForm = () => {
        validateFields()
            .then(data => {
                addDomain({
                    ...data,
                    domainType: type
                }, onClose);
            })
            .catch(() => {});
    };

    return (
        <Modal
            title={t("backoffice.projects.addDomain")}
            cancelText={t("backoffice.common.cancel")}
            okText={t("backoffice.common.add")}
            onOk={handleForm}
            disableOkButton={isSaving || value === ""}
            onCancel={onClose}
            size={POPUP_SIZE.SMALL}
        >
            <Form
                className="rt--form"
                form={formInstance}
                colon={false}
                requiredMark={false}
                layout="vertical"
                initialValues={{
                    domain: "",
                    manageDNS: false
                }}
            >
                <Row gutter={[16, 0]}>
                    <Col span={24}>
                        <Form.Item
                            label={`${t("backoffice.projects.domain")} *`}
                            name="domain"
                            rules={[
                                { required: true, whitespace: true, message: t('backoffice.validation.fieldRequired') },
                                { pattern: DOMAIN_REGEX, message: t( "backoffice.validation.fieldInvalid" ) },
                            ]}
                            validateFirst={true}
                            className="rt--general-form-item"
                            data-placeholder={`${t("backoffice.common.enter")} ${t("backoffice.projects.domain")}`}
                        >
                            <Input.Dropdown
                                placeholder={`${t("backoffice.common.enter")} ${t("backoffice.projects.domain")}`}
                                dropdownReadOnly={true}
                                items={[
                                    { label: "https://", value: "https://" },
                                ]}
                                onChange={e => setValue(e)}
                            />
                        </Form.Item>
                    </Col>

                    <Col span={24}>
                        <div className="rt--flex-inline rt--align-center rt--form-item-checkbox">
                            <Form.Item
                                className='rt--form-item-inline rt--form-item-without-margin'
                                name="manageDNS"
                                valuePropName='checked'
                            >
                                <Checkbox 
                                />
                            </Form.Item>
                            <span className='rt--title rt--font-normal rt--font-regular rt--pl-8'>{t('backoffice.projects.managedBySystem')}</span>
                        </div>
                    </Col>
                </Row>
            </Form>
        </Modal>
    );
};

const mapDispatchToProps = (dispatch) => ({
    addDomain: (data, onSuccess) => {
        dispatch(addDomain(data, onSuccess));
    },
});

const mapStateToProps = (state) => {
    return {
        isSaving: state.projects.isSaving,
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AddDomainComponent);
